import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../css/navbar.css';
import useAuth from '../hooks/useAuth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faBars } from '@fortawesome/free-solid-svg-icons';

const Navbar = ({ onClickOutside }) => {
  const { user, userId, displayName, userAvatar, discordServers, logout } = useAuth();
  const location = useLocation();
  const [userDropdownIsVisible, setUserDropdownIsVisible] = useState(false);
  const [mobileNavIsVisible, setMobileNavIsVisible] = useState(false);

  const userMenuRef = useRef(null);
  const toggleMenuRef = useRef(null);

  function rand(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  const defaultUserPhotoURL = `user-default-${rand(1,5)}.png`;

  let activeServer = {};
  for (const server of discordServers) {
    if(server.id === window.location.pathname.split('/')[2]) {
        activeServer = server;
        break;
    }
  }

  const toggleUserDropdown = () => {
    if (mobileNavIsVisible && !userDropdownIsVisible) {
      setMobileNavIsVisible(false);
    }
    setUserDropdownIsVisible(!userDropdownIsVisible);
  };

  const logoutUser = () => {
    setUserDropdownIsVisible(false);
    logout();
  };

  const loadUserProfile = () => {
    console.debug('Sending user to:', `/u/${userId}/profile`);
    setUserDropdownIsVisible(false);
    window.location.href = `/u/${userId}/profile`;
  };

  const loadServerProfile = (serverId) => () => {
    console.debug('Sending user to:', `/g/${serverId}`);
    setUserDropdownIsVisible(false);
    window.location.href = `/g/${serverId}`;
  };

  const toggleMobileNav = () => {
    if (userDropdownIsVisible && !mobileNavIsVisible) {
      setUserDropdownIsVisible(false);
    }
    setMobileNavIsVisible(!mobileNavIsVisible);
  };

  const handleResize = () => {
    if (window.innerWidth > 800) {
      setMobileNavIsVisible(false);
    }
  };

  const handleRouteChange = () => {
    setMobileNavIsVisible(false);
    setUserDropdownIsVisible(false);
  };

  useEffect(() => {
    handleRouteChange();
  }, [location]);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        userMenuRef.current &&
        !userMenuRef.current.contains(event.target) &&
        toggleMenuRef.current &&
        !toggleMenuRef.current.contains(event.target)
      ) {
        setUserDropdownIsVisible(false);
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [onClickOutside]);

  return (
    <div className="nav-container">
      <nav>
        <div className="mobile-nav">
          <FontAwesomeIcon icon={faBars} size="lg" onClick={toggleMobileNav} className="mobile-nav-icon pointer"/>
          {mobileNavIsVisible && (
            <div className="mobile-nav-dd padding-20 shadow-lg">
              <Link to="/" id="mobile-logo">
                <img src="/img/logo.png" alt="SquadBot" />
              </Link>
            </div>
          )}
        </div>
        <div className="flex-center text-bold logo-container">
          <a href='/'>
            {activeServer.id ?(
              <><img className="logo" src={"/img/logo.png"} alt={"SquadBot"} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>X</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img className="logo" src={`https://cdn.discordapp.com/icons/${activeServer.id}/${activeServer.icon}.webp?size=40`} alt={`${activeServer.name}`} /></>
            ) : (
              <><img className="logo" src="/img/logo.png" alt="SquadBot" />.dev</>
            )}
          </a>
        </div>
        {user ? (
          <div className="user-menu">
            <div
              className="flex-center text-bold pointer"
              ref={toggleMenuRef}
              onClick={toggleUserDropdown}
            >
              <div className="crop-wrapper">
                <img className="user-avatar" src={`https://cdn.discordapp.com/avatars/${userId}/${userAvatar}?size=40` || `/public/img/${defaultUserPhotoURL}`} />
              </div>
            </div>
            {userDropdownIsVisible && (
              <div ref={userMenuRef} className="user-dd padding-20 shadow-lg">
                <button onClick={loadUserProfile}>{displayName}</button>
                <button onClick={logoutUser}>Logout</button>
                {discordServers.length > 0 && (
                  <div>
                    <h5>Guilds:</h5>
                    <hr />
                    <ul>
                      {discordServers.map((server) => (
                        <li key={server.id}>
                          <button onClick={loadServerProfile(server.id)}>
                            <img src={`https://cdn.discordapp.com/icons/${server.id}/${server.icon}.png?size=40`} />
                            <span>{server.name}</span>
                          </button>
                        </li>
                      ))}
                    </ul>
                    <hr />
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          <div className="flex-center text-bold auth-links">
            <Link to={"/login" + (location.pathname == '/' ? '' : `?redirect=${location.pathname}`)}>Login</Link>
          </div>
        )}
      </nav>
    </div>
  );
};

export default Navbar;
